<template lang="html">
	<section
		class="relative pt-20 pb-16 overflow-hidden lg:pt-32 lg:pb-28 mt-4"
	>
		<div
			class="absolute top-0 right-0 w-80 h-80 bg-accent/5 rounded-full blur-3xl -translate-y-1/2"
		></div>
		<div
			class="absolute bottom-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-y-1/3"
		></div>
		<div
			class="absolute top-1/2 right-1/4 w-72 h-72 bg-brand-cyan/3 rounded-full blur-2xl"
		></div>

		<div class="relative max-w-screen-xl px-4 mx-auto lg:px-6">
			<div class="grid items-center gap-16 lg:grid-cols-2">
				<div class="space-y-8">
					<div
						class="inline-flex items-center px-4 py-2.5 space-x-2 text-sm font-medium text-primary bg-primary/5 rounded-full border border-primary/10 backdrop-blur-sm animate-fadeInDown"
					>
						<div
							class="w-2 h-2 bg-accent rounded-full animate-pulse"
						></div>
						<span>Kenya's Trusted Insurance Partner</span>
					</div>

					<div class="space-y-4">
						<h1
							class="text-5xl font-extrabold leading-tight text-textPrimary lg:text-6xl xl:text-7xl tracking-tight"
						>
							Welcome to
							<span class="block">
								<span class="relative inline-block">
									<span class="relative z-10 text-accent"
										>Nexus</span
									>
									<div
										class="absolute bottom-1 left-0 right-0 h-3 bg-gradient-to-r from-accent/30 to-accent/10 -rotate-1 blur-sm"
									></div>
								</span>
							</span>
						</h1>

						<p
							class="max-w-xl text-lg leading-relaxed text-textSecondary font-light lg:text-xl"
						>
							Experience seamless insurance solutions designed for
							modern Kenya. Get
							<span class="font-semibold text-primary"
								>personalized coverage</span
							>
							tailored to your needs in seconds.
						</p>
					</div>

					<div class="flex flex-col gap-4 pt-4 sm:flex-row">
						<button
							@click="$emit('go-to-insurance')"
							class="group inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold text-white bg-primary rounded-lg transition-all duration-300 ease-out hover:shadow-lg hover:shadow-primary/30 hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-2"
						>
							<svg
								class="w-5 h-5 mr-2.5 transition-transform duration-300 group-hover:scale-110"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2.5"
									d="M13 10V3L4 14h7v7l9-11h-7z"
								></path>
							</svg>
							Get Your Quotation
						</button>
					</div>

					<div
						class="grid grid-cols-3 gap-6 pt-8 border-t border-border"
					>
						<div class="flex flex-col">
							<div class="text-2xl font-bold text-primary">
								50K+
							</div>
							<div class="text-sm text-textSecondary">
								Satisfied Customers
							</div>
						</div>
						<div class="flex flex-col">
							<div class="text-2xl font-bold text-primary">
								99.9%
							</div>
							<div class="text-sm text-textSecondary">
								Uptime Guarantee
							</div>
						</div>
						<div class="flex flex-col">
							<div class="text-2xl font-bold text-primary">
								24/7
							</div>
							<div class="text-sm text-textSecondary">
								Expert Support
							</div>
						</div>
					</div>
				</div>

				<div class="relative">
					<div class="relative group">
						<div
							class="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent/5 rounded-2xl blur-2xl -z-10 group-hover:from-primary/15 group-hover:to-accent/10 transition-all duration-300"
						></div>

						<img
							src="/assets/images/famil.jpg"
							alt="Nexus Insurance - Family Protection"
							class="w-full h-auto rounded-2xl shadow-lg ring-1 ring-white/50 transition-all duration-300 group-hover:shadow-2xl group-hover:shadow-primary/20"
						/>

						<div
							class="absolute bottom-6 left-6 right-6 flex gap-3"
						>
							<div
								class="flex items-center gap-2 px-4 py-2.5 bg-white/95 backdrop-blur-md rounded-lg shadow-lg"
							>
								<svg
									class="w-5 h-5 text-accent"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										fill-rule="evenodd"
										d="M2.166 4.999A11.954 11.954 0 0110 1.944 11.954 11.954 0 0117.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
										clip-rule="evenodd"
									></path>
								</svg>
								<span
									class="text-sm font-semibold text-textPrimary"
									>100% Secure</span
								>
							</div>

							<div
								class="flex items-center gap-2 px-4 py-2.5 bg-white/95 backdrop-blur-md rounded-lg shadow-lg"
							>
								<svg
									class="w-5 h-5 text-brand-cyan"
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
									></path>
								</svg>
								<span
									class="text-sm font-semibold text-textPrimary"
									>Instant Quotes</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'HeroSection',
	emits: ['go-to-insurance', 'learn-more'],
};
</script>

<style scoped>
/* Entrance animations */
@keyframes slideInLeft {
	from {
		opacity: 0;
		transform: translateX(-30px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes slideInRight {
	from {
		opacity: 0;
		transform: translateX(30px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes shimmer {
	0%,
	100% {
		background-position: 200% center;
	}
	50% {
		background-position: -200% center;
	}
}

/* Apply animations */
h1 {
	animation: slideInLeft 0.8s ease-out;
}

p {
	animation: slideInLeft 0.8s ease-out 0.2s both;
}

div[class*='flex flex-col gap-4'] {
	animation: slideInLeft 0.8s ease-out 0.4s both;
}

div[class*='grid grid-cols-3'] {
	animation: slideInLeft 0.8s ease-out 0.6s both;
}

img {
	animation: slideInRight 0.8s ease-out 0.3s both;
}

/* Pulsing button effect */
button {
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

button:hover svg {
	animation: none;
}
</style>
